import Layout from "../include/layout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import PhoneInput from "react-phone-number-input";
import EtablissementsService from "./EtablissementsService";
import Filarial from "../include/filarial";
import EnseignantsService from "../enseignants/EnseignantsService";

export default function EtablissementCreate() {
    const activeLink = "ETABLISSEMENTS"

    const [errors, setErrors] = useState({});

    const [raisonsocialeEtablissement, setRaisonsocialeEtablissement] = useState("");
    const [sigleEtablissement, setSigleEtablissement] = useState("");
    const [dirigeantEtablissement, setDirigeantEtablissement] = useState("");
    const [telephoneprimaireEtablissement, setTelephoneprimaireEtablissement] = useState("");
    const [telephonesecondaireEtablissement, setTelephonesecondaireEtablissement] = useState("");
    const [emailEtablissement, setEmailEtablissement] = useState("");
    const [emailsupportEtablissement, setEmailSupportEtablissement] = useState("");
    const [adresseEtablissement, setAdresseEtablissement] = useState("");
    const [siteWeb, setSiteWeb] = useState("");
    const [boitePostale, setBoitePostale] = useState("");
    const [emailnotificationEtablissement, setEmailnotificationEtablissement] = useState("");
    const [fondateurEtablissement, setFondateurEtablissement] = useState("");
    const [signatureEtablissement, setSignatureEtablissement] = useState("");
    const [logoEtablissement, setLogoEtablissement] = useState("");
    
    const [laune_path, setLaUne] = useState("")
    const [validationError, setValidationError] = useState({});

    const token = useSelector(state => state.auth.token)
    const navigate = useNavigate()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

   

    ///Save form data
    const handleSubmitDataEtablissement = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("raisonsocialeEtablissement", raisonsocialeEtablissement);
        formData.append("sigleEtablissement", sigleEtablissement);
        formData.append("dirigeantEtablissement", dirigeantEtablissement);
        formData.append("telephoneprimaireEtablissement", telephoneprimaireEtablissement);
        formData.append("telephonesecondaireEtablissement", telephonesecondaireEtablissement);
        formData.append("emailEtablissement", emailEtablissement);
        formData.append("emailsupportEtablissement", emailsupportEtablissement);
        formData.append("adresseEtablissement", adresseEtablissement);
        formData.append("siteWeb", siteWeb);
        formData.append("boitePostale", boitePostale);
        formData.append("emailnotificationEtablissement", emailnotificationEtablissement);
        formData.append("fondateurEtablissement", fondateurEtablissement);
        formData.append("signatureEtablissement", signatureEtablissement);
        formData.append("logoEtablissement", logoEtablissement);

        /* for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
      } */
    
        try {
          const response = await EtablissementsService.store(formData, token);

          if (response.data.status === 200) {
            //redirection sur index
            navigate(myroutes.etablissements_index);
            Swal.fire({
              icon: "success",
              text: response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.data.message,
              showConfirmButton: true,
              timer: 3000,
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            text: error.message,
          });
        }
      };


    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }

    }, [dispatch]);

    return (
      <Layout>
        <div className="container-xxl flex-grow-1 container-p-y">
          <Filarial activeLink={activeLink} />

          <div className="row mb-4 mt-2">
            {/* Bootstrap Validation */}
            <div className="col-md">
              <div className="card shadow-lg">
                <h5 className="card-header">Enregistrement </h5>
                <div className="card-body">
                <Row>
                {Object.keys(validationError).length > 0 && (
                        <div className="row">
                            <div className="col-12">
                            <div className="alert alert-danger">
                                <ul className="mb-0">
                                {Object.keys(validationError).map((key) => (
                                    <li key={key}>{validationError[key]}</li>
                                ))}
                                </ul>
                            </div>
                            </div>
                        </div>
                        )}

                 </Row>
                  <Form
                    encType="multipart/form-data"
                    method="POST"
                    onSubmit={handleSubmitDataEtablissement}
                  >
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="raisonsocialeEtablissement"
                        >
                          Raison sociale <i className="text-danger">*</i>
                        </Form.Label>
                        <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-raisonsocialeEtablissement">
                                  La raison sociale doit être unique
                                </Tooltip>
                              }
                            >
                        <Form.Control
                          className="form-control"
                          id="raisonsocialeEtablissement"
                          type="text"
                          value={raisonsocialeEtablissement}
                          onChange={(e) =>
                            setRaisonsocialeEtablissement(e.target.value)
                          }
                          placeholder=""
                          required={true}
                          maxLength={100}
                          minLength={3}
                        />
                      </OverlayTrigger>
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="fondateurEtablissement"
                        >
                          Fondateur {" "}
                          <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          id="fondateurEtablissement"
                          type="text"
                          value={fondateurEtablissement}
                          onChange={(e) =>
                            setFondateurEtablissement(e.target.value)
                          } 
                          placeholder=""
                          required={false}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="dirigeantEtablissement"
                        >
                          Dirigeant <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          id="dirigeantEtablissement"
                          type="text"
                          value={dirigeantEtablissement}
                          onChange={(e) =>
                            setDirigeantEtablissement(e.target.value)
                          }
                          placeholder=""
                          maxLength={100}
                        />
                      </div>
                    </div>

                    <div className="row">
                    <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="adresseEtablissement"
                        >
                          Adresse Etablissement <i className="text-danger">*</i>
                        </Form.Label>
                      
                        <Form.Control
                          className="form-control"
                          id="adresseEtablissement"
                          type="text"
                          value={adresseEtablissement}
                          onChange={(e) =>
                            setAdresseEtablissement(e.target.value)
                          }
                          placeholder=""
                          maxLength={100}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="telephone"
                        >
                          Telephone primaire Etablissement{" "}
                          <i className="text-danger">*</i>
                        </Form.Label>
                        <PhoneInput
                                defaultCountry="BJ"
                                international
                                value={telephoneprimaireEtablissement}
                                onChange={(value) => setTelephoneprimaireEtablissement(value)}
                                id="telephone"
                                placeholder="Numéro de téléphone"
                                required={true}
                                className="custom-phone-inputx"
                              />
                       
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="telephone"
                        >
                          Telephone secondaire Etablissement{" "}
                          <i className="text-danger"></i>
                        </Form.Label>
                        <PhoneInput
                                defaultCountry="BJ"
                                international
                                value={telephonesecondaireEtablissement}
                                onChange={(value) => setTelephonesecondaireEtablissement(value)}
                                id="telephone"
                                placeholder="Numéro de téléphone"
                                required={true}
                                className="custom-phone-inputx"
                              />
                      </div>
                     
                    </div>

                    <div className="row">
                    <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="emailEtablissement"
                        >
                          Email Etablissement <i className="text-danger">*</i>
                        </Form.Label>
                        <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-email">
                                C'est l'email général de l'établissement 
                                </Tooltip>
                              }
                            >
                        <Form.Control
                          className="form-control"
                          id="emailEtablissement"
                          type="email"
                          value={emailEtablissement}
                          onChange={(e) =>
                            setEmailEtablissement(e.target.value)
                          }
                          placeholder=""
                          required={true}
                          maxLength={100}
                          minLength={3}
                        />
                        </OverlayTrigger>
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="emailsupportEtablissement"
                        >
                          Email support Etablissement{" "}
                          <i className="text-danger"></i>
                        </Form.Label>
                        <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-email">
                                C'est l'email utilisé par le support de l'établissement afin de résourdre certains problèmes
                                </Tooltip>
                              }
                            >
                        <Form.Control
                          className="form-control"
                          id="emailsupportEtablissement"
                          type="email"
                          value={emailsupportEtablissement}
                          onChange={(e) =>
                            setEmailSupportEtablissement(e.target.value)
                          } 
                           placeholder=""
                          maxLength={100}
                        />
                        </OverlayTrigger>
                      </div>
                    
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="emailnotificationEtablissement"
                        >
                          Email notification Etablissement{" "}
                          <i className="text-danger"></i>
                        </Form.Label>
                        <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-emailnotificationEtablissement">
                                C'est l'email utilisé pour envoyer des notifications dans l'établissement.
                                </Tooltip>
                              }
                            >
                        <Form.Control
                          className="form-control"
                          id="emailnotificationEtablissement"
                          type="email"
                          value={emailnotificationEtablissement}
                          onChange={(e) =>
                            setEmailnotificationEtablissement(e.target.value)
                          }
                          placeholder=""
                          maxLength={100}
                        />
                        </OverlayTrigger>
                      </div>
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="sigleEtablissement"
                        >
                          Sigle Etablissement <i className="text-danger">*</i>
                        </Form.Label>
                        <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-email">
                                  Le sigle de l'établissement est unique et propore à lui.
                                </Tooltip>
                              }
                            >
                        <Form.Control
                          className="form-control"
                          id="sigleEtablissement"
                          type="text"
                          value={sigleEtablissement}
                          onChange={(e) =>
                            setSigleEtablissement(e.target.value)
                          }
                          placeholder=""
                          required={true}
                          maxLength={100}
                          minLength={3}
                        />
                      </OverlayTrigger>
                      </div>

                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="siteWeb"
                        >
                          Site Web <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          id="siteWeb"
                          type="text"
                          value={siteWeb}
                          onChange={(e) =>
                            setSiteWeb(e.target.value)
                          }
                          placeholder=""
                          maxLength={100}
                        />
                      </div>
                     
                      <div className="col-md-4 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="boitePostale"
                        >
                          Boite Postale <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          id="boitePostale"
                          type="text"
                          value={boitePostale}
                          onChange={(e) =>
                            setBoitePostale(e.target.value)
                          } 
                          placeholder=""
                          maxLength={100}
                          minLength={3}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="signatureEtablissement"
                        >
                          Signature Etablissement{" "}
                          <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                          className="form-control"
                          id="signatureEtablissement"
                          type="text"
                          value={signatureEtablissement}
                          onChange={(e) =>
                            setSignatureEtablissement(e.target.value)
                          } 
                          placeholder=""
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <Form.Label
                          className="form-label"
                          htmlFor="logoEtablissement"
                        >
                          Logo Etablissement <i className="text-danger"></i>
                        </Form.Label>
                        <Form.Control
                              className=""
                              onChange={(e) =>
                                setLogoEtablissement(e.target.files[0])
                              }
                              name="logoEtablissement"
                              aria-label="logoEtablissement"
                              required
                              type="file"
                              id="logoEtablissement"
                              accept="image/jpeg, image/jpg, image/png, image/PNG, image/JPG, image/JPEG"
                            />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <button type="submit" className="btn btn-primary">
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            {/* /Bootstrap Validation */}
          </div>
        </div>
      </Layout>
    );
}